import { Tooltip } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import './AppTooltip.scss';

export const styleTooltip = {
  overlayInnerStyle: { color: '#111827' },
  color: '#F5F5F5'
};
const AppTooltip = forwardRef(({ children, title, width, styles, overflow, ...rest }: any, ref) => {
  const defaultInnerStyle = {
    maxWidth: width ?? '500px',
    overflow: overflow ?? 'auto',
    padding: '8px 16px',
    // width: 'fit-content',
    fontSize: '14px',
    maxHeight: '300px'
  };

  const [titleTooltip, setTiteTooltip] = useState<any>('');

  useEffect(() => {
    setTiteTooltip(title);
  }, [title]);

  useImperativeHandle(ref, () => ({
    setTitle(title: string) {
      setTiteTooltip(title);
    }
  }));

  return (
    <Tooltip
      placement='top'
      color={styleTooltip.color}
      overlayInnerStyle={{ ...defaultInnerStyle, ...styles, color: styleTooltip.overlayInnerStyle.color }}
      title={titleTooltip}
      {...rest}
    >
      {children}
    </Tooltip>
  );
});
export default AppTooltip;
